(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["services-scroll-story"] && !Shopify.designMode) return;
  try {
    
  const initializeServicesScroll = (root) => {
    if (!root || root.dataset.initialized === 'true') return;
    root.dataset.initialized = 'true';

    const items = [...root.querySelectorAll('[data-service-item]')];
    const links = [...root.querySelectorAll('[data-service-nav]')];
    if (!items.length) return;

    root.querySelectorAll('.services-scroll__service-form-message').forEach((message) => {
      const inquiry = message.closest('details');
      if (inquiry) inquiry.open = true;
      message.focus();
    });

    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    let animationFrame = 0;

    const centerActiveRailLink = (link) => {
      const rail = link.closest('.services-scroll__rail');
      if (!rail || rail.scrollWidth <= rail.clientWidth) return;

      const targetLeft = link.offsetLeft - (rail.clientWidth - link.offsetWidth) / 2;
      rail.scrollTo({
        left: Math.max(0, targetLeft),
        behavior: 'smooth',
      });
    };

    const activate = (index) => {
      items.forEach((item, itemIndex) => item.classList.toggle('is-active', itemIndex === index));
      links.forEach((link, linkIndex) => {
        const current = linkIndex === index;
        link.classList.toggle('is-active', current);
        if (current) {
          link.setAttribute('aria-current', 'step');
          centerActiveRailLink(link);
        } else {
          link.removeAttribute('aria-current');
        }
      });
    };

    activate(0);
    const observer = new IntersectionObserver(
      (entries) => {
        const visible = entries
          .filter((entry) => entry.isIntersecting)
          .sort((a, b) => b.intersectionRatio - a.intersectionRatio)[0];
        if (visible) activate(Number(visible.target.dataset.serviceItem));
      },
      { rootMargin: '-30% 0px -30% 0px', threshold: [0.1, 0.35, 0.6] }
    );

    items.forEach((item) => observer.observe(item));

    if (!reducedMotion) {
      root.classList.add('services-scroll--motion-ready');

      const renderScrollMotion = () => {
        animationFrame = 0;
        const viewportHeight = window.innerHeight;
        const rootRect = root.getBoundingClientRect();
        const scrollRange = Math.max(rootRect.height - viewportHeight, 1);
        const storyProgress = Math.min(1, Math.max(0, -rootRect.top / scrollRange));
        root.style.setProperty('--story-progress', storyProgress.toFixed(4));

        items.forEach((item) => {
          const rect = item.getBoundingClientRect();
          const distance = rect.top + rect.height / 2 - viewportHeight / 2;
          const range = (viewportHeight + rect.height) / 2;
          const progress = Math.min(1, Math.max(-1, distance / range));
          const visibility = Math.max(0.18, 1 - Math.abs(progress) * 0.92);

          item.style.setProperty('--media-shift', `${(-progress * 54).toFixed(2)}px`);
          item.style.setProperty('--content-shift', `${(progress * 52).toFixed(2)}px`);
          item.style.setProperty('--content-opacity', visibility.toFixed(3));
        });
      };

      const requestRender = () => {
        if (!animationFrame) animationFrame = window.requestAnimationFrame(renderScrollMotion);
      };

      renderScrollMotion();
      window.addEventListener('scroll', requestRender, { passive: true });
      window.addEventListener('resize', requestRender, { passive: true });
    }
  };

  document.querySelectorAll('[data-services-scroll]').forEach(initializeServicesScroll);
  document.addEventListener('shopify:section:load', (event) => {
    initializeServicesScroll(event.target.querySelector('[data-services-scroll]'));
  });

  } catch(e) { console.error(e); }
})();
})();
